module.exports = __webpack_public_path__ + "img/rigel1.ce067d0.png";